import React, {Component} from 'react'
import ReactSelect from 'react-select'

class Select extends Component {

    constructor(props) {
        super(props)

        this.state = {
            value: null
        }

        this.onChange = this.onChange.bind(this)
    }

    componentDidMount() {
        if (this.props.value) {
            if (!isNaN(this.props.value)) {
                this.setState({ value: parseInt(this.props.value) })
            } else {
                this.setState({ value: this.props.value })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value !== this.state.value) {
            if (parseInt(this.props.submitOnChange)) {
                this.refs.container.querySelector('input').form.submit(this.refs.container.parentNode)
            }
        }
        if ((this.props.type === 'cirkwi') && (this.props.value !== this.state.value)) {
            this.setState({ value: this.props.value })
        }
    }

    onChange(value) {
        if (value !== null && value.value === 'undefined') {
            this.setState({
                'value': null
            })
        } else {
            this.setState({ value })
        }
        if (this.props.onChange) {
            this.props.onChange(this.props.name, value)
        }
    }

    render() {
        return <div ref="container">
            <ReactSelect
                ref='select'
                name={this.props.name}
                value={this.state.value}
                options={this.props.options}
                placeholder={this.props.placeholder}
                onChange={this.onChange}
            />
        </div>
    }

}


export default Select



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/select/Select.js